import CXMApiClient from '../CXMApiClient';
import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";
function initialState() {
  return {
    ServiceSummary: {
      roCount: 0,
      customerPayTotal: 0,
      warrantyPayTotal: 0,
      dealerPaidTotal: 0,
      totalServiceValue: 0
    }
  };
}

const state = initialState();

const actions = {
  async getServiceSummaryByContactId(context, contactId) {
    // TODO: Send scope
    // const scope = HelperFunctions.getCurrentCustomerScope();
    let client = new CXMApiClient();
    return await client.ProcessRequest(
      "get",
      "/crm/contacts/" + contactId + "/service",
      null
    ).catch(err => err.response);
  },
  async getServiceSummaryForCurrentContact(context) {
    context.commit("setServiceSummaryForCurrentContact", {});
    const response = await context.dispatch("getServiceSummaryByContactId", context.getters.CurrentContact.id);
    if (response && response.data && response.data.successful)
      context.commit("setServiceSummaryForCurrentContact", response.data.data);

    // const scope = HelperFunctions.getCurrentCustomerScope();
    // return new Promise(async (resolve, reject) => {
    //   let client = new CXMApiClient();
    //   resolve(
    //     client
    //       .ProcessRequest(
    //         "get",
    //         "/crm/contacts/" + context.getters.CurrentContact.id + "/service",
    //         null,
    //         scope
    //       )
    //       .then(r => {
    //         if (r && r.data.successful) {
    //           context.commit("setServiceSummaryForCurrentContact", r.data.data);
    //         } else {
    //           reject(response);
    //         }
    //       })
    //       .catch(err => reject(err))
    //   );
    // });
  }
};

const mutations = {
  setServiceSummaryForCurrentContact(state, data) {
    state.ServiceSummary = data;
  }
};

export default {
  state,
  actions,
  mutations
};




// WEBPACK FOOTER //
// ./src/store/modules/Service.js